import React, { useState } from "react";
import axios from "axios";
import { ReactMediaRecorder } from "react-media-recorder";
import { Paper, Button, CircularProgress, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';

function Home() {
  const [text, setText] = useState("");
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(false);

  const url = "http://localhost:5522";

  const onStop = async (blobUrl, blob) => {
    setLoading(true);
    // Envia o áudio para o backend
    const formData = new FormData();
    formData.append("audio", blob, "audio.wav");

    try {
      // Transcreve o áudio
      const transcribeResponse = await axios.post(
        url + "/transcribe",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setText(transcribeResponse.data.text);

      // Sumariza o texto
      const summarizeResponse = await axios.post(
        url + "/summarize",
        {
          text: transcribeResponse.data.text,
        }
      );
      setSummary(summarizeResponse.data.summary);
    } catch (error) {
      console.error("Erro ao processar áudio ou texto:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Prontuário com IA
      </Typography>
      <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
        <ReactMediaRecorder
          audio
          onStop={onStop}
          render={({ status, startRecording, stopRecording }) => (
            <div className="recorder">
              <Typography variant="body1">
                {status === "idle" && "Pronto para gravar"}
                {status === "recording" && "Gravando..."}
                {status === "stopped" && "Gravação parada"}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<MicIcon />}
                onClick={startRecording}
                style={{ marginRight: '10px' }}
              >
                Iniciar Gravação
              </Button>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<StopIcon />}
                onClick={stopRecording}
              >
                Parar Gravação
              </Button>
            </div>
          )}
        />
      </Paper>
      {loading && <CircularProgress />}
      <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
        <Typography variant="h5">Texto Capturado:</Typography>
        <Typography variant="body1">{text}</Typography>
      </Paper>
      <Paper elevation={3} style={{ padding: '20px' }}>
        <Typography variant="h5">Sumário:</Typography>
        <Typography variant="body1">
          <div dangerouslySetInnerHTML={{ __html: summary }} />
        </Typography>
      </Paper>
    </div>
  );
}

export default Home;
